<app-header></app-header>
<div class="container-fluid">
  @if (protocol['name']) {
    <h2>{{getHumanName(protocol['name'])}}</h2>
  }
  <hr>
  <div fxLayout="column">
    <div fxLayout="row" fxLayout.lt-md="column">
      <dt fxFlex="25">Protocol: </dt>
      <dd fxFlex="75">
        <app-robust-link [link]="link" [text]="protocol['filename']"></app-robust-link>
        <a href="{{protocol['url']}}"><span class="glyphicon glyphicon-download-alt" aria-hidden="true"></span></a>
      </dd>
    </div>
    <div fxLayout="row" fxLayout.lt-md="column">
      <dt fxFlex="25">Experiment target: </dt>
      <dd fxFlex="75">{{protocol['experimentTarget']}}</dd>
    </div>
    <div fxLayout="row" fxLayout.lt-md="column">
      <dt fxFlex="25">Assay type: </dt>
      <dd fxFlex="75">{{protocol['assayType']}}</dd>
    </div>
  </div>
  <hr>

  @if (protocol['experiments'] && protocol['experiments'].length > 0) {
    <h3 style="margin: 20px 0 20px 0;">Related Experiments</h3>
  }
  <div [hidden]="!protocol['experiments'] || protocol['experiments'].length == 0" class="table-responsive">

    <table mat-table matSort matSortDisableClear [dataSource]="dataSource" table-striped style="width: 100%">
      @for (col of display_fields; track col; let i = $index) {
        <ng-container [matColumnDef]=col>
          <th mat-header-cell class="table-header" *matHeaderCellDef mat-sort-header> {{column_names[i]}} </th>
          @if (col == 'accession') {
            <td mat-cell class="table-cell-data" *matCellDef="let item">
              <a href="#" (click)="onClick(item[col]); ngxSmartModalService.getModal('myModal').open()">
                {{item[col]}}
              </a>
            </td>
          }
          @if (col != 'accession') {
            <td mat-cell class="table-cell-data" *matCellDef="let item">
              {{item[col]}}
            </td>
          }
        </ng-container>
      }
      <tr mat-header-row *matHeaderRowDef="display_fields"></tr>
      <tr mat-row *matRowDef="let row; columns: display_fields;"></tr>
    </table>
    <mat-paginator pageSize="10"></mat-paginator>
  </div>

  <ngx-smart-modal #myModal identifier="myModal" class="nsm-dialog-animation-fade" customClass="msg-modal">
    <h3>{{experimentId}}</h3>
    <hr>
    @if (experiment && fieldNames) {
      @for (key of objectKeys(fieldNames); track key) {
        @if (experiment.hasOwnProperty(key) && checkIsObject(experiment[key])) {
          @if (experiment[key].hasOwnProperty('filename')) {
            <p>
              <b>{{fieldNames[key]}}: </b> <br>
              <app-robust-link [link]="experiment[key]['url']" [text]="experiment[key]['filename'] | slice:0:62"></app-robust-link>
            </p>
          }
          @if (experiment[key].hasOwnProperty('text')) {
            <p>
              <b>{{fieldNames[key]}}: </b> <br>
              {{experiment[key]['text']}} ({{experiment[key]['unit']}})
            </p>
          }
        }
        @if (experiment.hasOwnProperty(key) && !checkIsObject(experiment[key])) {
          <p>
            <b>{{fieldNames[key]}}: </b> <br>
            {{experiment[key]}}
          </p>
        }
      }
    }
    <button mat-raised-button color="primary" (click)="myModal.close()">Close</button>
  </ngx-smart-modal>
</div>
